// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__WvZPJ","content":"LayoutSettings_content__7-Jls"};